export const MAX_NUMBER_OF_JOBS = 10000;
export const MAX_NUMBER_OF_ROBOTS = 1000;
export const MAX_NUMBER_OF_RESULTS = 20;
